<template>
  <div
    v-loading="loading"
    class="subprogram-nba-page app-content"
  >
    <!-- Header -->
    <div
      v-if="tabs[activeTabIndex]"
      class="subprogram-nba-page__header"
    >
      <!-- Back button -->
      <app-back-button
        route-name="programList"
        :text-button="backButtonText ? backButtonText : ''"
      />

      <div class="subprogram-nba-page__header__text">
        <span
          class="subprogram-nba-page__header__text__title"
          v-text="title"
        />
        <span
          class="subprogram-nba-page__header__text__description"
          v-text="description"
        />
      </div>
      <!-- **************** -->
      <!-- Scundary buttons -->
      <!-- **************** -->
      <!-- Secundary Button Summary -->
      <div
        v-if="tabs[activeTabIndex].type === 'summary'"
        class="subprogram-nba-page__header__buttons app-content-create"
      >
        <!-- First Button -->
        <router-link
          v-if="programType"
          :to="{ name: 'programSubprogramEdit',
                 params: {id: subprogramId, propertyId, subpropertyId, programId, programType} }"
        >
          <el-button type="secondary">
            <app-i18n :code="tabs[activeTabIndex].editButtonCode" />
          </el-button>
        </router-link>

        <!-- Secondary button summary -->
        <app-subprogram-nba-summary-start-season-button
          v-if="subpropertyId &&
            programId &&
            enabledStartRegularSeason
          "
          :property-id="propertyId"
          :subproperty-id="subpropertyId"
          :program-id="programId"
          :subprogram-id="subprogramId"
        />

        <!-- Third button summary -->
        <app-subprogram-nba-summary-start-playoffs-button
          v-if="subpropertyId &&
            programId &&
            enabledStartPlayoffs
          "
          :property-id="propertyId"
          :subproperty-id="subpropertyId"
          :program-id="programId"
          :subprogram-id="subprogramId"
        />
      </div>

      <!-- Secundary button schedule -->
      <div class="app-content-create">
        <app-filter-button
          v-if="tabs[activeTabIndex].type === 'schedule'"
          :active.sync="activeScheduleFilter"
        />
      </div>

      <!-- Primary button rounds -->
      <div
        v-if="tabs[activeTabIndex].type === 'rounds' && enabledStartRegularSeason"
        class="subprogram-nba-page__header__buttons app-content-create"
      >
        <router-link
          :to="{
            name: 'SubprogramRegularSeasonRoundsNew',
            params: {programId, subprogramId}
          }"
        >
          <el-button type="primary">
            <app-i18n :code="tabs[activeTabIndex].createButtonCode" />
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- ******* -->
    <!-- Filters -->
    <!-- ******* -->
    <app-subprogram-nba-schedule-filter
      v-if="tabs[activeTabIndex] && tabs[activeTabIndex].type === 'schedule'"
      :style="{ display: activeScheduleFilter ? 'initial' : 'none' }"
      :program-id="programId"
      :subprogram-id="subprogramId"
    />

    <!-- ******** -->
    <!-- Contents -->
    <!-- ******** -->
    <app-subprogram-nba-summary
      v-if="subpropertyId && tabs[activeTabIndex] && tabs[activeTabIndex].type === 'summary'"
    />
    <app-subprogram-nba-schedule-table
      v-else-if="tabs[activeTabIndex] && tabs[activeTabIndex].type === 'schedule'"
      :program-id="programId"
      :subprogram-id="subprogramId"
    />
    <app-subprogram-nba-standings-page
      v-else-if="tabs[activeTabIndex] && tabs[activeTabIndex].type === 'standings'"
    />
    <app-subprogram-nba-rounds-table
      v-else-if="tabs[activeTabIndex] && tabs[activeTabIndex].type === 'rounds'"
      :program-id="programId"
      :subprogram-id="subprogramId"
      :is-regular-season-configured="enabledStartRegularSeason"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SubprogramNbaSumary from '@modules/subprogram/nba/components/subprogram-nba-summary.vue'
import SubprogramNbaSummaryStartSeasonButton from '@modules/subprogram/nba/components/subprogram-nba-summary-start-season-button.vue'
import SubprogramNbaSummaryStartPlayoffsButton from '@modules/subprogram/nba/components/subprogram-nba-summary-start-playoffs-button.vue'
import SubprogramNbaScheduleTable from '@modules/subprogram/nba/components/subprogram-nba-schedule-table.vue'
import SubprogramNbaScheduleFilter from '@modules/subprogram/nba/components/subprogram-nba-schedule-filter.vue'
import SubprogramNbaStandings from '@modules/subprogram/nba/components/subprogram-nba-standings-page.vue'
import SubprogramNbaRoundsTable from '@modules/subprogram/nba/components/subprogram-nba-rounds-table.vue'
import { get, isEmpty } from 'lodash'
import { i18n } from '@shared/i18n'

export default {
  name: 'SubprogramNbaPage',

  components: {
    [SubprogramNbaSumary.name]: SubprogramNbaSumary,
    [SubprogramNbaSummaryStartSeasonButton.name]: SubprogramNbaSummaryStartSeasonButton,
    [SubprogramNbaSummaryStartPlayoffsButton.name]: SubprogramNbaSummaryStartPlayoffsButton,
    [SubprogramNbaScheduleTable.name]: SubprogramNbaScheduleTable,
    [SubprogramNbaStandings.name]: SubprogramNbaStandings,
    [SubprogramNbaScheduleFilter.name]: SubprogramNbaScheduleFilter,
    [SubprogramNbaRoundsTable.name]: SubprogramNbaRoundsTable,
  },

  props: {
    tabName: {
      type: String,
    },
    programId: {
      type: String,
      required: true,
    },
    subprogramId: {
      type: String,
      required: true,
    },
  },

  beforeRouteUpdate(to, from, next) {
    if (isEmpty(this.$route.query)) {
      this.setActiveFilter(true)
    }
    next();
  },

  data() {
    return {}
  },
  
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      tabIndex: 'subprogram/nba/tabIndex',
      tabs: 'subprogram/nba/tabs',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      program: 'subprogram/nba/program',
      subprogram: 'subprogram/nba/subprogram',
      loading: 'subprogram/nba/loading',
      activeFilter:
        'subprogram/nba/schedule/activeFilter',
    }),
    activeScheduleFilter: {
      get() {
        return this.activeFilter
      },
      set(val) {
        this.setActiveFilter(val)
      },
    },

    propertyId() {
      return get(this, 'currentManage.property.id', null)
    },

    subpropertyId() {
      return get(
        this,
        'currentManage.subproperty.id',
        null,
      )
    },

    programType() {
      return get(this, 'program.type', null)
    },

    backButtonText() {
      const programName = get(this, 'program.name')
      // const programNamei18n = i18n('common.back.default');
      return programName
    },

    enabledStartRegularSeason() {
      return !get(
        this,
        'subprogram.regularSeasonConfigured',
        true,
      )
    },

    enabledStartPlayoffs() {
      const regularSeasonStarted = get(this, 'subprogram.regularSeasonConfigured', false)
      const playoffsStarted = get(this, 'subprogram.playoffsStarted', false)
      return regularSeasonStarted && !playoffsStarted
    },

    title() {
      const programType = get(this, 'program.type', '')
      const programi18n = i18n(`enumerators.programType.${programType}`)
      const programName = get(this, 'program.name', '')
      const subprogramName = get(this, 'subprogram.name', '')

      if (!programName || !subprogramName || !programType) {
        return ''
      }

      return `${programi18n} ${programName} · ${subprogramName}`
    },
    description() {
      const subprogramGender = get(this, 'subprogram.gender', '')
      const subprogramGenderi18n = i18n(`enumerators.gender.${subprogramGender}`)

      if (!subprogramGender) {
        return ''
      }

      return subprogramGenderi18n
    },
  },

  mounted() {
    this.doInitParams({
      subpropertyId: this.subpropertyId,
      programId: this.programId,
      subprogramId: this.subprogramId,
    })
  },

  created() {
    const { subprogram, subprogramId } = this
    if (subprogram && subprogramId) {
      if (subprogram.id !== subprogramId) {
        this.doReset({
          subpropertyId: this.subpropertyId,
          programId: this.programId,
          subprogramId: this.subprogramId,
        })
      }
    }
  },

  beforeDestroy() {
    this.resetTabs()
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
      setTabIndex: 'subprogram/nba/setTabIndex',
      doResetTabs: 'subprogram/nba/doResetTabs',
      doInitParams: 'subprogram/nba/doInitParams',
      doStartRegularSeason: 'subprogram/nba/summary/doStartRegularSeason',
      setActiveFilter: 'subprogram/nba/schedule/setActiveFilter',
      doReset: 'subprogram/nba/schedule/doReset',
    }),

    parseActiveTab() {
      let { tabIndex } = this

      if (this.tabName) {
        tabIndex = this.tabs.findIndex(({ type }) => type == this.tabName)
      }
      this.setTabIndex(tabIndex)
      this.setActiveTabIndex(this.tabIndex)
    },
  },

  watch: {
    activeTabIndex: {
      handler: 'parseActiveTab',
    },
    tabs() {
      this.doResetTabs()
      this.setTabs(this.tabs)
      this.parseActiveTab()
    },
  },
}
</script>

<style lang="scss" scoped>
.subprogram-nba-page {
  &__header {
    display: grid;
    grid-template-areas: 'back buttons' 'text buttons';
    &__buttons {
      grid-area: buttons;
      justify-self: end;
      display: grid;
      grid-auto-flow: column;
      grid-column-gap: 16px;

      &--ml16 {
        margin-left: 16px;
      }
    }

    &__text {
      grid-area: text;
      display: grid;
      height: 56px;
      padding-top: 32px;
      &__title {
        font-size: 22px;
        font-weight: 500;
        text-transform: uppercase;
        padding-bottom: 4px;
        color: #6b6d72;
      }
      &__description {
        font-size: 14px;
        color: #76787d;
        text-transform: capitalize;
      }
    }
  }
}
</style>
